<section class="container">
    <div class="text-center flex justify-center w-full flex-col items-center">
        <!-- svelte-ignore a11y-missing-attribute -->
        <img
            loading="lazy"
            src="/nodata.webp"
            height="600"
            width="600"
            class="img-fluid"
        />
        <div class="text-center">
            <p class="text-black h5-default">Hasil Tidak Ditemukan</p>
        </div>
    </div>
</section>
